import { DataProvider } from 'react-admin'
import { SchemeDto } from '../../dto/scheme/scheme.dto'

const fakeSchemes: SchemeDto[] = [
  {
    id: 1,
    name: 'scheme fake name',
    parentId: 1,
    childrensIds: [1, 2, 3, 4, 5],
    logSchemeDataIds: [1, 2, 3, 4, 5],
    palmSchemeDataIds: [1, 2, 3, 4, 5],
    hierarchy: [
      { id: 1, name: 'name1' },
      { id: 2, name: 'name2' },
      { id: 3, name: 'name3' },
      { id: 4, name: 'name4' },
      { id: 5, name: 'name5' },
    ],
  },
  {
    id: 2,
    name: 'scheme fake name',
    parentId: 1,
    childrensIds: [1, 2, 3, 4, 5],
    logSchemeDataIds: [1, 2, 3, 4, 5],
    palmSchemeDataIds: [1, 2, 3, 4, 5],
    hierarchy: [
      { id: 1, name: 'name1' },
      { id: 2, name: 'name2' },
      { id: 3, name: 'name3' },
      { id: 4, name: 'name4' },
      { id: 5, name: 'name5' },
    ],
  },
  {
    id: 3,
    name: 'scheme fake name',
    parentId: 1,
    childrensIds: [1, 2, 3, 4, 5],
    logSchemeDataIds: [1, 2, 3, 4, 5],
    palmSchemeDataIds: [1, 2, 3, 4, 5],
    hierarchy: [
      { id: 1, name: 'name1' },
      { id: 2, name: 'name2' },
      { id: 3, name: 'name3' },
      { id: 4, name: 'name4' },
      { id: 5, name: 'name5' },
    ],
  },
  {
    id: 4,
    name: 'scheme fake name',
    parentId: 1,
    childrensIds: [1, 2, 3, 4, 5],
    logSchemeDataIds: [1, 2, 3, 4, 5],
    palmSchemeDataIds: [1, 2, 3, 4, 5],
    hierarchy: [
      { id: 1, name: 'name1' },
      { id: 2, name: 'name2' },
      { id: 3, name: 'name3' },
      { id: 4, name: 'name4' },
      { id: 5, name: 'name5' },
    ],
  },
  {
    id: 5,
    name: 'scheme fake name',
    parentId: 1,
    childrensIds: [1, 2, 3, 4, 5],
    logSchemeDataIds: [1, 2, 3, 4, 5],
    palmSchemeDataIds: [1, 2, 3, 4, 5],
    hierarchy: [
      { id: 1, name: 'name1' },
      { id: 2, name: 'name2' },
      { id: 3, name: 'name3' },
      { id: 4, name: 'name4' },
      { id: 5, name: 'name5' },
    ],
  },
  {
    id: 6,
    name: 'scheme fake name',
    parentId: 1,
    childrensIds: [1, 2, 3, 4, 5],
    logSchemeDataIds: [1, 2, 3, 4, 5],
    palmSchemeDataIds: [1, 2, 3, 4, 5],
    hierarchy: [
      { id: 1, name: 'name1' },
      { id: 2, name: 'name2' },
      { id: 3, name: 'name3' },
      { id: 4, name: 'name4' },
      { id: 5, name: 'name5' },
    ],
  },
  {
    id: 7,
    name: 'scheme fake name',
    parentId: 1,
    childrensIds: [1, 2, 3, 4, 5],
    logSchemeDataIds: [1, 2, 3, 4, 5],
    palmSchemeDataIds: [1, 2, 3, 4, 5],
    hierarchy: [
      { id: 1, name: 'name1' },
      { id: 2, name: 'name2' },
      { id: 3, name: 'name3' },
      { id: 4, name: 'name4' },
      { id: 5, name: 'name5' },
    ],
  },
  {
    id: 8,
    name: 'scheme fake name',
    parentId: 1,
    childrensIds: [1, 2, 3, 4, 5],
    logSchemeDataIds: [1, 2, 3, 4, 5],
    palmSchemeDataIds: [1, 2, 3, 4, 5],
    hierarchy: [
      { id: 1, name: 'name1' },
      { id: 2, name: 'name2' },
      { id: 3, name: 'name3' },
      { id: 4, name: 'name4' },
      { id: 5, name: 'name5' },
    ],
  },
  {
    id: 9,
    name: 'scheme fake name',
    parentId: 1,
    childrensIds: [1, 2, 3, 4, 5],
    logSchemeDataIds: [1, 2, 3, 4, 5],
    palmSchemeDataIds: [1, 2, 3, 4, 5],
    hierarchy: [
      { id: 1, name: 'name1' },
      { id: 2, name: 'name2' },
      { id: 3, name: 'name3' },
      { id: 4, name: 'name4' },
      { id: 5, name: 'name5' },
    ],
  },
  {
    id: 10,
    name: 'scheme fake name',
    parentId: 1,
    childrensIds: [1, 2, 3, 4, 5],
    logSchemeDataIds: [1, 2, 3, 4, 5],
    palmSchemeDataIds: [1, 2, 3, 4, 5],
    hierarchy: [
      { id: 1, name: 'name1' },
      { id: 2, name: 'name2' },
      { id: 3, name: 'name3' },
      { id: 4, name: 'name4' },
      { id: 5, name: 'name5' },
    ],
  },
]

const provider = {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getList: (resource, params) =>
    Promise.resolve({
      data: fakeSchemes,
      total: fakeSchemes.length,
    }),
} as DataProvider

export default provider
